import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Building2, Landmark } from "lucide-react";
import { NeuDropdown } from "./NeuDropdown";
import { listBranches } from "../../api/directory";
import { listStandards } from "../../api/gl";
import { localName } from "../../lib/localName";

// شريط نطاق الفرع + شارة النظام المحاسبي والعملة للفرع المختار.
export const ScopeBar = ({ value, onChange, testid = "scope-bar" }) => {
  const { t, i18n } = useTranslation();
  const [branches, setBranches] = useState([]);
  const [standards, setStandards] = useState([]);
  const ar = i18n.language === "ar";

  useEffect(() => {
    listBranches().then((rows) => setBranches(rows || [])).catch(() => setBranches([]));
    listStandards().then((data) => setStandards(data.items || [])).catch(() => setStandards([]));
  }, []);

  const branch = branches.find((row) => row.id === value);
  const standard = standards.find((row) => row.code === (branch?.accounting_standard || "IFRS"));
  const currency = branch?.primary_currency || branch?.payroll?.currency;

  return (
    <div className="grid gap-2">
      <NeuDropdown testid={`${testid}-select`} icon={Building2} value={value} onChange={onChange}
                   placeholder={t("purchases.allBranches")}
                   options={[{ value: "", label: t("purchases.allBranches") },
                             ...branches.map((row) => ({ value: row.id, label: row.name }))]} />
      {branch && standard ? (
        <div data-testid={`${testid}-standard`}
             className="flex flex-wrap items-center gap-2 rounded-2xl bg-primary/5 px-4 py-2 text-[11px] shadow-neu-in">
          <Landmark className="h-3.5 w-3.5 text-primary" />
          <span className="font-bold text-muted-foreground">{t("scope.standardLabel")}:</span>
          <span className="font-bold text-primary">{localName(standard)}</span>
          {currency ? (
            <>
              <span className="text-muted-foreground/60">·</span>
              <span className="font-bold text-muted-foreground">{t("scope.currencyLabel")}:</span>
              <span className="num font-mono font-bold text-emerald-600">{currency}</span>
            </>
          ) : null}
          {standard.vat_default_rate ? (
            <>
              <span className="text-muted-foreground/60">·</span>
              <span className="font-bold text-muted-foreground">VAT:</span>
              <span className="num font-mono font-bold text-amber-600">{standard.vat_default_rate}%</span>
            </>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};
